<template>
  <div>
    <div>
      <b-card-group>
        <b-card no-body>
          <b-collapse visible id="filterCollapse">
            <div class="card-body donor-form"> 
              <div>
                <b-form>
                  <b-row>
                    <filter-select
                    :cols="1"
                    :label="$t('Код РР')"
                    v-on:onChange="filterChanged"
                    v-if="!$auth.user().isLab"
                    :disabled="$auth.user().isLr"
                    v-model="form.lrOrganizationId"
                    :options="lrOrganizations"
                    class="small-padding"
                  ></filter-select>
                    <filter-input
                      :label="$t('ID')"
                       v-on:onBlur="filterChanged"
                      :cols="1"
                      v-model="form.labId"
                      class="small-padding"
                    ></filter-input>
                    <filter-input
                      :label="$t('Фамилия')"
                       v-on:onBlur="filterChanged"
                      v-if="!$auth.user().isLab"
                      :cols="1"
                      v-model="form.lastName"
                      class="small-padding"
                    ></filter-input>
                    <filter-input
                      :label="$t('Имя')"
                       v-on:onBlur="filterChanged"
                      v-if="!$auth.user().isLab"
                      :cols="1"
                      v-model="form.firstName"
                      class="small-padding"
                    ></filter-input>
                    <filter-input
                      :label="$t('Отчество')"
                       v-on:onBlur="filterChanged"
                      v-if="!$auth.user().isLab"
                      :cols="1"
                      v-model="form.patronymicName"
                      class="small-padding"
                    ></filter-input>
                    <template v-else>
                      <filter-input
                      :label="$t('№ акта из лаб.')"
                       v-on:onBlur="filterChanged"
                      placeholder="с"
                      :cols="1"
                      v-model="form.certificateNumberFrom"
                      class="small-padding"
                      ></filter-input>
                      <filter-input
                        label="&nbsp;"
                         v-on:onBlur="filterChanged"
                        placeholder="по"
                        :cols="1"
                        v-model="form.certificateNumberTo"
                        class="small-padding"
                      ></filter-input>
                    </template>
                    <filter-select
                      :label="$t('Пол')"
                      v-on:onChange="filterChanged"
                      v-model="form.gender"
                      :empty-as-null="true"
                      :cols="1"
                      :options="genders"
                      class="small-padding"
                    ></filter-select>
                    <filter-select
                      :label="$t('Является донором крови?')"
                      v-on:onChange="filterChanged"
                      v-model="form.isBloodDonor"
                      v-if="!$auth.user().isLab"
                      :empty-as-null="true"
                      :cols="2"
                      :options="yesNo"
                      class="small-padding"
                    ></filter-select>
                    <template v-else>
                      <filter-date-between
                        :label="$t('Дата рождения')"
                         v-on:onBlur="filterChanged"
                        :cols="2"
                        v-model="birthdayDateRange"
                        class="small-padding"
                      ></filter-date-between>
                      <filter-date-between
                        :label="$t('Дата заполнения анкеты')"
                        v-on:onChange="filterChanged"
                        :cols="2"
                        v-model="signedDateRange"
                        class="small-padding"
                      ></filter-date-between>
                    </template>
                    <filter-select
                      :label="$t('Статус')"
                      v-model="form.statuses"
                      v-on:onChange="filterChanged"
                      :withoutEmpty="true"
                      :multiple="true"
                      :empty-as-null="true"
                      :cols="2"
                      :options="formStatuses"
                      class="small-padding"
                    ></filter-select>
                    <b-col cols="1">
                      <b-button v-if="!isReport" v-on:click="search" size="sm" variant="primary" class="ml-2 search-btn">
                        <font-awesome-icon icon="search" />
                        {{ $t('Поиск') }}
                      </b-button>
                    </b-col>
                  </b-row>
                  <b-row v-if="!$auth.user().isLab">
                    <filter-date-between
                      :label="$t('Дата поступления')"
                      v-on:onChange="filterChanged"
                      :cols="2"
                      v-model="receiptinDateRange"
                      class="small-padding"
                    ></filter-date-between>
                    <filter-date-between
                      :label="$t('Дата установки статуса')"
                      v-on:onChange="filterChanged"
                      :cols="2"
                      v-model="statusDateRange"
                      class="small-padding"
                    ></filter-date-between>
                    <filter-date-between
                      :label="$t('Дата рождения')"
                      v-on:onChange="filterChanged"
                      :cols="2"
                      v-model="birthdayDateRange"
                      class="small-padding"
                    ></filter-date-between>
                    <filter-input
                      :label="$t('Возраст')"
                       v-on:onBlur="filterChanged"
                      placeholder="с"
                      :cols="1"
                      type="number"
                      v-model="form.ageFrom"
                      class="small-padding"
                    ></filter-input>
                    <filter-input
                      label="&nbsp;"
                       v-on:onBlur="filterChanged"
                      placeholder="по"
                      :cols="1"
                      type="number"
                      v-model="form.ageTo"
                      class="small-padding"
                    ></filter-input>
                    <filter-date-between
                      :label="$t('Дата активации')"
                      v-on:onChange="filterChanged"
                      :cols="2"
                      v-model="activatedDateRange"
                      class="small-padding"
                    ></filter-date-between>
                    <b-col cols="1">
                      <b-button v-if="!isReport" v-on:click="resetFilter" size="sm" variant="secondary" class="ml-2">
                        <font-awesome-icon icon="times" />
                        {{ $t('Сброс') }}
                      </b-button>
                    </b-col>
                  </b-row>
                  <b-row v-if="!$auth.user().isLab">
                    <filter-input
                      :label="$t('№ акта из лаб.')"
                       v-on:onBlur="filterChanged"
                      placeholder="с"
                      :cols="1"
                      v-model="form.certificateNumberFrom"
                      class="small-padding"
                    ></filter-input>
                    <filter-input
                      label="&nbsp;"
                       v-on:onBlur="filterChanged"
                      placeholder="по"
                      :cols="1"
                      v-model="form.certificateNumberTo"
                      class="small-padding"
                    ></filter-input>
                    <filter-input
                      :label="$t('Телефон')"
                       v-on:onBlur="filterChanged"
                      :cols="2"
                      v-model="form.phone"
                      class="small-padding"
                    ></filter-input>
                    <div class="small-padding col-sm-8 col-md-4 col-lg-4 col-xl-2 col-12">
                      <div role="group" class="b-form-group form-group">
                          <label for="input" class="col-form-label pt-0">
                            E-Mail
                          </label>
                          <div>
                            <b-input-group :size="'sm'">
                              <template #prepend>
                                <b-dropdown :size="'sm'" :text="form.hasMail == 1 ? 'Почта есть' : form.hasMail == 0 ? 'Почты нет' : ''" variant="success">
                                  <b-dropdown-item @click="form.hasMail = 1;">Почта есть</b-dropdown-item>
                                  <b-dropdown-item @click="form.hasMail = 0; form.email = '';">Почты нет</b-dropdown-item>
                                  <b-dropdown-item @click="form.hasMail = null;"><b>Сбросить фильтр</b></b-dropdown-item>
                                </b-dropdown>
                              </template>
                              <b-form-input :size="'sm'" v-on:onBlur="filterChanged" :disabled="form.hasMail === 0" v-model="form.email"></b-form-input>
                            </b-input-group>
                          </div>
                      </div>
                    </div>  
                    <filter-select
                      :label="$t('Национальность')"
                      v-on:onChange="filterChanged"
                      :withoutEmpty="true"
                      v-model="form.nationalities"
                      :empty-as-null="true"
                      :cols="2"
                      :multiple="true"
                      :options="nationalitiesList"
                      class="small-padding nationalities-filter"
                    >
                      <b-dropdown :size="'sm'" :text="form.hasNationality == 1 ? 'Национальность есть' : form.hasNationality == 0 ? 'Национальности нет' : ''" variant="success">
                        <b-dropdown-item @click="form.hasNationality = 1;">Национальность есть</b-dropdown-item>
                        <b-dropdown-item @click="form.hasNationality = 0; form.nationalities = []">Национальности нет</b-dropdown-item>
                        <b-dropdown-item @click="form.hasNationality = null"><b>Сбросить фильтр</b></b-dropdown-item>
                      </b-dropdown>
                    </filter-select>
                    <filter-input
                      :label="$t('Вес')"
                       v-on:onBlur="filterChanged"
                      placeholder="с"
                      :cols="1"
                      type="number"
                      v-model="form.weightFrom"
                      class="small-padding"
                    ></filter-input>
                    <filter-input
                      label="&nbsp;"
                       v-on:onBlur="filterChanged"
                      placeholder="по"
                      :cols="1"
                      type="number"
                      v-model="form.weightTo"
                      class="small-padding"
                    ></filter-input>
                    <b-col :cols="6" :sm="4" :md="2" :lg="2" :xl="1"></b-col>
                  </b-row>
                  <b-row v-if="!$auth.user().isLab">
                    <filter-select
                      :label="$t('Наличие заболеваний?')"
                      v-on:onChange="filterChanged"
                      v-model="form.hasDiseases"
                      :empty-as-null="true"
                      :cols="2"
                      :options="yesNo"
                      class="small-padding"
                    ></filter-select>
                    <filter-select
                      :label="$t('Были переливания крови?')"
                      v-on:onChange="filterChanged"
                      v-model="form.hasBloodTransfusion"
                      :empty-as-null="true"
                      :cols="2"
                      :options="yesNo"
                      class="small-padding"
                    ></filter-select>
                    <filter-select
                      :label="$t('Были хирургич. вмешательства?')"
                      v-on:onChange="filterChanged"
                      v-model="form.hasSurgery"
                      :empty-as-null="true"
                      :cols="2"
                      :options="yesNo"
                      class="small-padding"
                    ></filter-select>
                    <filter-select
                      :label="$t('Образец')"
                      v-on:onChange="filterChanged"
                      :withoutEmpty="true"
                      v-model="form.biomaterialSampleIds"
                      :empty-as-null="true"
                      :cols="2"
                      :multiple="true"
                      :options="biomaterialSamples"
                      class="small-padding"
                    ></filter-select>
                    <filter-select
                      :label="$t('Откуда вы о нас узнали')"
                      v-on:onChange="filterChanged"
                      :withoutEmpty="true"
                      v-model="form.learnedFromIds"
                      :empty-as-null="true"
                      :cols="2"
                      :multiple="true"
                      :options="learnedFroms"
                      class="small-padding"
                    ></filter-select>
                    <b-col :cols="6" :sm="4" :md="2" :lg="2" :xl="1"></b-col>
                  </b-row>
                  <b-row v-if="!$auth.user().isLab">
                    <filter-select
                      :label="$t('Регион')"
                      v-on:onChange="filterChanged"
                      :withoutEmpty="true"
                      v-model="form.regionIds"
                      :empty-as-null="true"
                      :cols="3"
                      :multiple="true"
                      :options="regions"
                      class="small-padding"
                    ></filter-select>
                    <filter-input
                      :label="$t('Город')"
                       v-on:onBlur="filterChanged"
                      :cols="1"
                      v-model="form.city"
                      class="small-padding"
                    ></filter-input>
                    <filter-select
                      :label="$t('Первичная причина удаления')"
                      v-on:onChange="filterChanged"
                      :withoutEmpty="true"
                      v-model="form.initialDeletionReasonIds"
                      :empty-as-null="true"
                      :cols="2"
                      :multiple="true"
                      :options="initialDeletionReasons"
                      class="small-padding"
                    ></filter-select>
                    <filter-select
                      :label="$t('Окончательная причина удаления')"
                      v-on:onChange="filterChanged"
                      :withoutEmpty="true"
                      v-model="form.deletionReasonIds"
                      :empty-as-null="true"
                      :cols="2"
                      :multiple="true"
                      :options="deletionReasons"
                      class="small-padding"
                    ></filter-select>
                    <filter-date-between
                      :label="$t('Дата заполнения соглашения')"
                      v-on:onChange="filterChanged"
                      :cols="2"
                      v-model="signedDateRange"
                      class="small-padding"
                    ></filter-date-between>
                    <b-col :cols="6" :sm="4" :md="2" :lg="2" :xl="1"></b-col>
                  </b-row>
                  <b-row>
                    <filter-select
                      :label="$t('Данные о поступлении')"
                      v-on:onChange="filterChanged"
                      v-model="form.entryType"
                      :empty-as-null="true"
                      :withoutEmpty="true"
                      :multiple="true"
                      :cols="2"
                      :options="entryTypes"
                      class="small-padding"
                    ></filter-select>
                    <filter-select
                      :label="$t('Акция')"
                      v-on:onChange="filterChanged"
                      v-model="form.entryActionId"
                      :empty-as-null="true"
                      :cols="2"
                      :options="entryActions"
                      class="small-padding"
                    ></filter-select>
                    <filter-select
                      :label="$t('Мед. учреждение')"
                      v-on:onChange="filterChanged"
                      v-model="form.entryMedicalOfficeId"
                      :empty-as-null="true"
                      :withoutEmpty="true"
                      :multiple="true"
                      :cols="2"
                      :options="entryMedicalOffices"
                      class="small-padding"
                    ></filter-select>
                    <filter-input
                      :label="$t('Город (акция / клиники, СПК)')"
                       v-on:onBlur="filterChanged"
                      :cols="2"
                      v-model="form.incomeCity"
                      class="small-padding"
                    ></filter-input>
                    <filter-select
                      :label="$t('Приоритетные')"
                      v-on:onChange="filterChanged"
                      v-model="form.isPriority"
                      :empty-as-null="true"
                      :cols="1"
                      :options="yesNo"
                      class="small-padding"
                    ></filter-select>
                    <filter-checkbox
                        :label="$t('Нет связи')"
                        v-model="form.noConnection"
                        :cols="1"
                        v-on:onChange="changeNoConnection"
                    ></filter-checkbox>
                    <b-col :cols="6" :sm="4" :md="2" :lg="2" :xl="1"></b-col>
                  </b-row>
                </b-form>
              </div>
            </div>
          </b-collapse>
        </b-card>
      </b-card-group>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import BaseFilter from '@/models/base.filter';
import { EventBus } from '@/event-bus';

export default {
  extends: BaseFilter,
  name: 'filter-form',
  props: [
    'id',
    'labId',
    'firstName',
    'lastName',
    'patronymicName',
    'gender',
    'statuses',
    'ageFrom',
    'ageTo',
    'certificateNumberFrom',
    'certificateNumberTo',
    'isBloodDonor',
    'createdFrom',
    'createdTo',
    'activatedFrom',
    'activatedTo',
    'weightFrom',
    'weightTo',
    'dateOfBirthFrom',
    'dateOfBirthTo',
    'receiptInFrom',
    'receiptInTo',
    'signedAtFrom',
    'signedAtTo',
    'statusDateFrom',
    'statusDateTo',
    'lrOrganizationId',
    'phone',
    'email',
    'regionIds',
    'initialDeletionReasonIds',
    'biomaterialSampleIds',
    'deletionReasonIds',
    'learnedFromIds',
    'nationalities',
    'city',
    'hasDiseases',
    'isPriority',
    'hasMail',
    'hasNationality',
    'hasBloodTransfusion',
    'hasSurgery',
    'incomeCity',
    'entryMedicalOfficeId',
    'entryType',
    'entryActionId',
    'noConnection',
    'isReport',
  ],
  data() {
    return {
      isReport: this.isReport,
      form: {
        id: this.id || null,
        labId: this.labId || null,
        firstName: this.firstName || null,
        lastName: this.lastName || null,
        patronymicName: this.patronymicName || null,
        phone: this.phone || null,
        email: this.email || null,
        city: this.city || null,
        gender: this.gender || null,
        statuses: this.statuses || [],
        biomaterialSampleIds: this.biomaterialSampleIds || [],
        learnedFromIds: this.LearnedFromIds || [],
        regionIds: this.regionIds || [],
        deletionReasonIds: this.deletionReasonIds || [],
        initialDeletionReasonIds: this.initialDeletionReasonIds || [],
        isBloodDonor: this.isBloodDonor || null,
        hasDiseases: this.hasDiseases || null,
        isPriority: this.isPriority || null,
        hasMail: this.hasMail || null,
        hasNationality: this.hasNationality || null,
        hasBloodTransfusion: this.hasBloodTransfusion || null,
        hasSurgery: this.hasSurgery || null,
        createdFrom: this.createdFrom || null,
        createdTo: this.createdTo || null,
        activatedFrom: this.activatedFrom || null,
        activatedTo: this.activatedTo || null,
        dateOfBirthFrom: this.dateOfBirthFrom || null,
        dateOfBirthTo: this.dateOfBirthTo || null,
        signedAtFrom: this.signedAtFrom || null,
        signedAtTo: this.signedAtTo || null,
        receiptInFrom: this.receiptInFrom || null,
        receiptInTo: this.receiptInTo || null,
        statusDateFrom: this.statusDateFrom || null,
        statusDateTo: this.statusDateTo || null,
        certificateNumberFrom: this.certificateNumberFrom || null,
        certificateNumberTo: this.certificateNumberTo || null,
        nationalities: this.nationalities || [],
        ageFrom: this.ageFrom || null,
        ageTo: this.ageTo || null,        
        weightFrom: this.weightFrom || null,
        weightTo: this.weightTo || null,
        lrOrganizationId: this.lrOrganizationId || null,
        entryType: this.entryType || [],
        incomeCity: this.incomeCity || null,
        entryMedicalOfficeId: this.entryMedicalOfficeId || [],
        entryActionId: this.entryActionId || null,
        noConnection: this.noConnection || false,
      },
      createDateRange: [],
      activatedDateRange: [],
      birthdayDateRange: [],
      receiptinDateRange: [],
      signedDateRange: [],
      statusDateRange: [],
      formStatuses: [],
      genders: [],
      biomaterialSamples: [],
      nationalitiesList: [],
      regions: [],
      deletionReasons: [],
      initialDeletionReasons: [],
      entryTypes: [],
      entryActions: [],
      entryMedicalOffices: [],
      yesNo: [],
      learnedFroms: [],
      lrOrganizations: [],
    };
  },
  mounted() {
    const createFrom = this.createdFrom ? new Date(this.createdFrom) : this.createdFrom;
    const createTo = this.createdTo ? new Date(this.createdTo) : this.createdTo;
    this.createDateRange = [createFrom, createTo];
    
    const activatedFrom = this.activatedFrom ? new Date(this.activatedFrom) : this.activatedFrom;
    const activatedTo = this.activatedTo ? new Date(this.activatedTo) : this.activatedTo;
    this.activatedDateRange = [activatedFrom, activatedTo];
    
    const dateOfBirthFrom = this.dateOfBirthFrom ? new Date(this.dateOfBirthFrom) : this.dateOfBirthFrom;
    const dateOfBirthTo = this.dateOfBirthTo ? new Date(this.dateOfBirthTo) : this.dateOfBirthTo;
    this.birthdayDateRange = [dateOfBirthFrom, dateOfBirthTo];

    const receiptInFrom = this.receiptInFrom ? new Date(this.receiptInFrom) : this.receiptInFrom;
    const receiptInTo = this.receiptInTo ? new Date(this.receiptInTo) : this.receiptInTo;
    this.receiptinDateRange = [receiptInFrom, receiptInTo];
    
    const signedAtFrom = this.signedAtFrom ? new Date(this.signedAtFrom) : this.signedAtFrom;
    const signedAtTo = this.signedAtTo ? new Date(this.signedAtTo) : this.signedAtTo;
    this.signedDateRange = [signedAtFrom, signedAtTo];

    const statusDateFrom = this.statusDateFrom ? new Date(this.statusDateFrom) : this.statusDateFrom;
    const statusDateTo = this.statusDateTo ? new Date(this.statusDateTo) : this.statusDateTo;
    this.statusDateRange = [statusDateFrom, statusDateTo];
    this.mapMultiselectValues(['region', 'biomaterialSample', 'learnedFrom',
                               'initialDeletionReason', 'deletionReason']);
    this.applyDateRangeWatcher();
    let self = this;
    EventBus.$on('gridDataLoaded', function(data) {
      self.regions = data.regions;
    });
  },
  methods: {
    changeNoConnection() {
      this.form.noConnection = !this.form.noConnection;
    },
    mapMultiselectValues(keys) {
      for(let i = 0; i < keys.length; i++) {
        let key = keys[i];
        let data = this.form[key + 'Ids'];
        if(data) {
          this.form[key + 'Ids'] = Array.isArray(data) ? data.map(Number) : [parseInt(data)];
        }
      }
    },
    applyDateRangeWatcher() {
      this.$watch('createDateRange', function() {
        this.form.createdFrom = this.createDateRange[0] ? this.createDateRange[0].toJSON() : '';
        this.form.createdTo = this.createDateRange[1] ? this.createDateRange[1].toJSON() : '';
      });
      this.$watch('activatedDateRange', function() {
        this.form.activatedFrom = this.activatedDateRange[0] ? this.activatedDateRange[0].toJSON() : '';
        this.form.activatedTo = this.activatedDateRange[1] ? this.activatedDateRange[1].toJSON() : '';
      });
      this.$watch('birthdayDateRange', function() {
        this.form.dateOfBirthFrom = this.birthdayDateRange[0] ? this.birthdayDateRange[0].toJSON() : '';
        this.form.dateOfBirthTo = this.birthdayDateRange[1] ? this.birthdayDateRange[1].toJSON() : '';
      }),
      this.$watch('receiptinDateRange', function() {
        this.form.receiptInFrom = this.receiptinDateRange[0] ? this.receiptinDateRange[0].toJSON() : '';
        this.form.receiptInTo = this.receiptinDateRange[1] ? this.receiptinDateRange[1].toJSON() : '';
      }),
      this.$watch('signedDateRange', function() {
        this.form.signedAtFrom = this.signedDateRange[0] ? this.signedDateRange[0].toJSON() : '';
        this.form.signedAtTo = this.signedDateRange[1] ? this.signedDateRange[1].toJSON() : '';
      }),
      this.$watch('statusDateRange', function() {
        this.form.statusDateFrom = this.statusDateRange[0] ? this.statusDateRange[0].toJSON() : '';
        this.form.statusDateTo = this.statusDateRange[1] ? this.statusDateRange[1].toJSON() : '';
      });
    },
    getDictionaries() {
      axios.get('/Dictionary/GetLrOrganizationCodes')
           .then((response) => {
            this.lrOrganizations = response.data;
          });
      axios.get('/pmdd/DictionaryGroup')
        .then((response) => {
          this.genders = response.data.genders;
          this.biomaterialSamples = response.data.biomaterial_samples;
          this.nationalitiesList = response.data.nationalities;
          this.learnedFroms = response.data.learned_froms;
          if(this.regions.length == 0) {
            this.regions = response.data.regions;
          }
          this.deletionReasons = response.data.deletion_reasons;
          this.initialDeletionReasons = response.data.initial_deletion_reasons;
          this.entryTypes = response.data.entry_types;
          this.entryActions = response.data.entry_actions;
          this.entryMedicalOffices = response.data.entry_medical_offices;
          this.yesNo = response.data.yes_no;
          this.formStatuses = response.data.statuses;
        });
    },
    search: function() {
      this.$emit('search', this.form);
    },
    filterChanged: function() {
      this.$emit('filterChanged', this.form);
    },
    resetFilter(e) {
      this.reset(e, () => {
        this.createDateRange = [];
        this.activatedDateRange = [];
        this.birthdayDateRange = [];
        this.receiptinDateRange = [];
        this.signedDateRange = [];
        this.statusDateRange = [];
        this.form.statuses = [];
        this.form.entryMedicalOfficeId = [];
        this.form.entryType = [];
        this.form.regionIds = [];
        this.form.nationalities = [];
        this.form.learnedFromIds = [];
        this.form.deletionReasonIds = [];
        this.form.initialDeletionReasonIds = [];
        this.form.biomaterialSampleIds = [];
        this.form.hasNationality = null;
        this.form.hasMail = null;
        this.form.noConnection = false;
      });
    },
  },
};
</script>
